import React from 'react';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';
import { Button as ShadcnButton } from 'shadcn-ui';
import useFeatureToggleService from 'feature-toggle';

export interface SubmitPopupButtonProps {
  text?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  isDisabled?: boolean;
  onClick: () => Promise<void>;
  size?: ButtonSize;
  color?: ButtonColor;
}

function LegacySubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const text = props.text || 'Submit';

  const size = props.size || ButtonSize.BIG;
  const color = props.color || ButtonColor.GREEN;

  const onClickFunc = async () => {
    await props.onClick();
  };

  return (
    <Button
      text={text}
      onClick={onClickFunc}
      color={color}
      size={size}
      isSubmitButton
    />
  );
}

function ShadcnSubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const text = props.text || 'Submit';

  return (
    <ShadcnButton
      type="submit"
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
    >
      {text}
    </ShadcnButton>
  );
}

export default function SubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSubmitPopupButtonLayout {...props} />;
  } else {
    return <LegacySubmitPopupButtonLayout {...props} />;
  }
}
